export default __webpack_public_path__ + "static/media/p04 p02.23a066a7.jpg";